import React, { Component } from "react";

import {
  Card,
  Button,
  Table,
  Modal,
  Select,
  Input,
  message,
  Tooltip,
} from "antd";

import { connect } from "react-redux";
import {
  req_page_gqm_alumniApplyCard,
  req_downloadfile_gqm_alumniApplyCard,
  req_single_ams_alumni,
  req_edit_gqm_alumniApplyCard,
} from "../../api";
import {
  API_BASE,
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { usrRole } from "../../utils/dataUtil";
import storageUtils from "../../utils/storageUtils";

import AdumniGraduateModal from "./alumni-graduate-modal";
import AdumniSelfModal from "./alumni-self-modal";

class AlumniCardManage extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    deviceWidth: 0,
    loading: false,
    userLevel: "NORMAL",
    items: [],
    item: {},
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "None",
    searchValue: "",
    filterStatus: "",
    domnloadFile: "",
    isShowModal: false,
    isSelfModal: false,
    FixRemitFiveCode: "",
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.api_page_items(1);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resize.bind(this));
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_page_items = async (current) => {
    this.current = current; // 保存當前頁，給其他方法可看到
    const { pageSize } = this.state.pagination;
    const { searchField, searchValue, columnSort, orderBy, filterStatus } =
      this.state;
    const { token, userCode, role } = this.props.user;

    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });
    this.setState({ loading: true });
    const result = await req_page_gqm_alumniApplyCard(
      userCode,
      userLevel,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      token
    );
    this.setState({ loading: false });
    //console.log(result)
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination });
      //console.log(this.state);
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination });
    }
  };

  api_single_alumni = async (obj) => {
    const { token } = this.props.user;
    const { TwId } = obj;
    this.setState({ loading: true });
    const result = await req_single_ams_alumni(TwId, token);
    this.setState({ loading: false });
    const item = result;
    this.setState({ item }, () => {
      this.setState({ isShowModal: true });
    });
  };

  api_downloadfile_items = async () => {
    const { userLevel, searchField, searchValue, filterStatus } = this.state;
    const { token, userCode } = this.props.user;

    // download file data
    const fileUrl = await req_downloadfile_gqm_alumniApplyCard(
      userCode,
      userLevel,
      searchField,
      searchValue,
      filterStatus,
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "校友清單";
    a.click();
  };

  api_edit_item = async (item) => {
    // this.setState({ finishPage: true });

    const result = await req_edit_gqm_alumniApplyCard(
      item,
      storageUtils.getUser().token
    );
    if (result.status === "success") {
      // console.log(result)
      // this.api_single_item();
    } else {
      message.error(result.message);
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "銀行五碼",
        width: 20,
        responsive: ["md"],
        render: (item) => {
          const { CaseStatus, RemitFiveCode, IsEmailSend } = item;
          return (
            <div className="text-center">
              {IsEmailSend === "PAY" ? (
                ""
              ) : (
                <>
                  <Input
                    placeholder=""
                    style={{ width: 70, margin: "0 5px" }}
                    defaultValue={RemitFiveCode}
                    onChange={(event) =>
                      this.setState({ FixRemitFiveCode: event.target.value })
                    }
                    disabled={CaseStatus === "DONE"}
                  />
                  <button
                    type="button"
                    className="btn btn-outline-dark btn-sm"
                    onClick={() => this.handle_fixCode_modal(item)}
                    disabled={CaseStatus === "DONE"}
                  >
                    <i className="fas fa-edit"></i>{" "}
                    <span style={{ marginLeft: "4px" }}>修改</span>
                  </button>
                </>
              )}
            </div>
          );
        },
      },
      {
        title: "姓名",
        dataIndex: "AlumniName",
        width: 30,
        responsive: ["md"],
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "領取方式",
        dataIndex: "IsEmailSend",
        width: 20,
        responsive: ["md"],
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.3em" }}>
                {" "}
                {field === "MAIL" ? (
                  <span style={{ color: "red" }}>掛號郵寄</span>
                ) : field === "SELF" ? (
                  <span style={{ color: "blue" }}>親取匯款</span>
                ) : (
                  <span style={{ color: "green" }}>親取現繳</span>
                )}
              </span>
            </div>
          );
        },
      },
      {
        title: "電話",
        dataIndex: "MobilePrincipal",
        width: 30,
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "電郵",
        dataIndex: "EmailPrincipal",
        width: 40,
        responsive: ["md"],
      },
      {
        title: "地址",
        dataIndex: "MailingAddress",
        width: 50,
        render: (field) => {
          return (
            <div>
              <span> {field}</span>
            </div>
          );
        },
      },
      {
        title: "操作項目",
        dataIndex: "",
        width: 40,
        render: (item) => {
          const { CaseStatus } = item;
          return (
            <>
              <Button
                type="dashed"
                size="small"
                onClick={() => this.handle_show_ui_modal("view", item)}
              >
                <i className="fas fa-user-alt"></i>{" "}
                <span style={{ marginLeft: "4px" }}>校內資料</span>
              </Button>
              <Button
                type="dashed"
                size="small"
                onClick={() => this.handle_show_ui_modal("self", item)}
              >
                <i className="fa fa-id-card"></i>{" "}
                <span style={{ marginLeft: "4px" }}>自填資料</span>
              </Button>
              <select
                name="CaseStatus"
                id="CaseStatus"
                className="custom-select mb-3 text-success"
                defaultValue={CaseStatus}
                onChange={(e) => {
                  this.setState({ item: item }, () => {
                    this.handleChange(e);
                  });
                }}
                key={CaseStatus}
                size={"small"}
                disabled={CaseStatus === "DONE"}
              >
                {" "}
                <option value="APPLY">尚未處理</option>
                <option value="PAID">繳費待辦</option>
                <option value="NOTIFY">通知取件</option>
                <option value="CANCEL">註銷撤案</option>
                <option value="DONE">處理完成</option>
              </select>
            </>
          );
        },
      },
    ];
  };

  style_switch_color_tag(column, param) {
    if (column === "NowStatusPrimary") {
      switch (param) {
        case "就業":
        case "服役":
        case "升學":
        case "留學":
          return "green";
        case "其他":
          return "purple";
        default:
          return "default";
      }
    }
    if (column === "NowStatusSecondary") {
      switch (param) {
        case "尚待確認":
          return "red";
        case "就業":
        case "服役":
        case "升學":
        case "留學":
          return "green";
        case "其他":
          return "purple";
        default:
          return "default";
      }
    }
    if (column === "ConfirmStatus") {
      switch (param) {
        case "NO":
          return "red";
        case "YES":
          return "green";
        default:
          return "default";
      }
    }
  }
  // 操作互動處理 //////////////////////////////////////////////

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_data_download = () => {
    this.api_downloadfile_items();
  };

  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  handle_fixCode_modal = (item) => {
    const { FixRemitFiveCode } = this.state;
    const { Uid } = item;
    const obj = {
      condition: "FIXCODE",
      Uid: Uid,
      RemitFiveCode: FixRemitFiveCode,
    };
    this.api_edit_item(obj);
    message.success("修改成功");
  };

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  handle_show_ui_modal = (modal, item) => {
    switch (modal) {
      case "view":
        this.api_single_alumni(item);
        break;
      case "self":
        this.setState({ isSelfModal: true, item });
        break;
      default:
    }
  };

  handleChange = (event) => {
    const { item } = this.state;
    const { userCode } = this.props.user;
    item.CaseStatus = event.target.value;
    item.condition = "BASE";
    item.RecordProcessUserId = userCode;

    this.api_edit_item(item);
    //console.log(item);
  };
  /////////////////////////////////////////////////////////////

  render() {
    const {
      deviceWidth,
      loading,
      item,
      items,
      pagination,
      searchField,
      searchValue,
      isSelfModal,
      isShowModal,
    } = this.state;
    const title = (
      <>
        <Select
          value={searchField}
          style={{ width: 120 }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="None">搜索條件</Select.Option>
          <Select.Option value="RemitFiveCode">銀行五碼</Select.Option>
          <Select.Option value="TwId">身分證字號</Select.Option>
          <Select.Option value="AlumniName">姓名</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 150, margin: "0 5px" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search element-hidden"></i> 查詢
        </Button>{" "}
        <Tooltip placement="top" title="重新整理">
          <Button type="primary" onClick={() => this.handle_data_refresh()}>
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>{" "}
        {deviceWidth > 600 ? (
          <>
            <Button type="primary" onClick={() => this.handle_data_download()}>
              <i className="fas fa-cloud-download-alt element-hidden"></i> 下載
            </Button>
          </>
        ) : (
          ""
        )}
      </>
    );
    return (
      <Card title={title}>
        <Table
          bordered
          scroll={{ y: 480 }}
          loading={loading}
          rowKey="Uid"
          dataSource={items}
          onChange={this.handle_table_change}
          pagination={{
            ...pagination,
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            // onChange: this.api_page_applycase,
            onShowSizeChange: this.handle_page_size_change,
          }}
          columns={this.columns}
        />
        <Modal
          destroyOnClose={true}
          title="校內資料"
          visible={isShowModal}
          width={"80%"}
          onOk={() => {
            this.setState({ isShowModal: false });
          }}
          onCancel={() => {
            this.setState({ isShowModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <AdumniGraduateModal alumni={item} />
        </Modal>
        <Modal
          destroyOnClose={true}
          title="自填資料"
          visible={isSelfModal}
          width={"450px"}
          onOk={() => {
            this.setState({ isSelfModal: false });
          }}
          onCancel={() => {
            this.setState({ isSelfModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <AdumniSelfModal alumni={item} />
        </Modal>
      </Card>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(AlumniCardManage);
